import dayjs from "dayjs";
import { UserFriendlyError } from "../../../../../common/utils/base_error";
import { IUpdateInspecaoObraWithValidationUseCase } from "../../../presentation/useCases/update/update_inspecao_obra_with_validation_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateInspecaoObraWithValidationUseCase
 */

export class UpdateInspecaoObraWithValidationUseCase implements IUpdateInspecaoObraWithValidationUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateInspecaoObraWithValidation(
    idObra: number,
    idInspecaoObra: number,
    idFuncionarioInspecionado: number | null,
    idFuncionarioAprovado: number | null,
    status: number,
    dataEncerramento: Date | null,
    file1: File | null,
    limparArquivo1: boolean,
    file2: File | null,
    limparArquivo2: boolean,
    file3: File | null,
    limparArquivo3: boolean,
    file4: File | null,
    limparArquivo4: boolean,
    file5: File | null,
    limparArquivo5: boolean,
    observacoes: string | null,
    descricaoArquivo1: string | null,
    descricaoArquivo2: string | null,
    descricaoArquivo3: string | null,
    descricaoArquivo4: string | null,
    descricaoArquivo5: string | null,
    inspecaoObraItens: {
      idInspecaoObraItem: number;
      inspecao1: string;
      dataInspecao1: Date | null;
      inspecao2: string;
      dataInspecao2: Date | null;
    }[],
  ): Promise<void> {
    const validacao = this.validaInspecaoObraItens(
      status,
      dataEncerramento,
      idFuncionarioAprovado,
    );

    if (validacao) {
      await this.repository.updateInspecaoObraWithValidation(
        idObra,
        idInspecaoObra,
        idFuncionarioInspecionado,
        idFuncionarioAprovado,
        status,
        dataEncerramento,
        file1,
        limparArquivo1,
        file2,
        limparArquivo2,
        file3,
        limparArquivo3,
        file4,
        limparArquivo4,
        file5,
        limparArquivo5,
        observacoes,
        descricaoArquivo1,
        descricaoArquivo2,
        descricaoArquivo3,
        descricaoArquivo4,
        descricaoArquivo5,
        inspecaoObraItens,
      );
    }
  }

  private validaInspecaoObraItens(
    status: number,
    dataEncerramento: Date | null,
    idFuncionarioAprovado: number | null,
  ): boolean {
    if (dataEncerramento !== null) {
      if (dayjs(dataEncerramento).isAfter(dayjs(), 'day')) {
        throw new UserFriendlyError('A data de encerramento não pode ser posterior a data atual!');
      }
    }

    // Encerrada
    if (status === 1) {
      if (dataEncerramento === null) {
        throw new UserFriendlyError('Preencha a data de encerramento!');
      }
      if (idFuncionarioAprovado === null) {
        throw new UserFriendlyError('Selecione o responsável pela aprovação!');
      }
    }
    return true;
  }
}
